import { Menu } from '@material-ui/core'
import styled from 'styled-components'
import {
  PRIMARY_TEXT,
  PURPLE_RGB,
  TERTIARY_TEXT,
  GRAY2,
  BLACK_RGB,
  PURPLE,
  LIGHT_PURPLE,
} from 'constants/colors'

export const StyledMenu = styled(Menu)<{
  $isSelectedFilters?: boolean
  $noTransform?: boolean
}>`
  font-size: 16px;
  line-height: 24px;

  .MuiMenu-paper {
    transform: translateY(42px) !important;
    min-width: 240px;
    color: ${PRIMARY_TEXT};
    border-radius: 8px;
    border: 1px solid ${GRAY2};
    box-shadow: 0px 2px 20px 0px rgba(${BLACK_RGB}, 0.1);

    > ul {
      padding: 0;
      margin: 12px;
    }
  }
`

export const MenuTitle = styled.div`
  color: ${TERTIARY_TEXT};
  font-weight: 600;
  padding: 10px 16px;
  line-height: 20px;
  font-size: 14px;
`

export const StyledListItem = styled.div.attrs(() => ({
  button: false,
}))`
  > li {
    width: auto;
    padding: 10px;
    border-radius: 8px;
    min-width: 210px;
    color: ${PRIMARY_TEXT};
    font-size: 14px;
    line-height: 20px;

    .MuiRadio-root,
    .MuiCheckbox-root {
      margin-right: 8px;
    }

    &:hover {
      cursor: pointer;
      background: rgba(${PURPLE_RGB}, 0.15);

      .MuiRadio-root,
      .MuiCheckbox-root {
        .MuiIconButton-label {
          > span {
            box-shadow: 0 0 0 3px ${LIGHT_PURPLE};
          }
        }

        .MuiIconButton-label {
          > span {
            border-color: ${PURPLE};
          }
        }
      }
    }
  }
`
